exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profile-img-area[data-v-450dc5c5]{border:1px solid #aaa;overflow:hidden;margin:auto}.original-image-area[data-v-450dc5c5]{position:fixed;width:100%;top:0;left:0;height:100%;background-color:rgba(0,0,0,.8);display:none;z-index:2000}", ""]);

